export default __webpack_public_path__ + "static/media/vietcapital.2cb2286f.png";